


/**
 * 调用客户端方法获取实时地址
 */
function getLocationFromNative() {
    return new Promise((resolve, reject) => {
        MJSSDK.invocation({
            action: 'getCurrentLocation',
            data: {},
            success(res) {
                resolve(res);
            },
            fail(err) {
                // {code:2,data:{}}
                reject(err);
            }
        });
    });
}

/**
 * 调用百度地图 api 获取实时地址
 * @param baiduMapAk 百度秘钥
 */
function getLocationFromBaidu(baiduMapAk) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `//api.map.baidu.com/api?v=2.0&ak=${baiduMapAk}&callback=baiduMapInit`;
        document.body.appendChild(script);

        window.baiduMapInit = () => {
            const geolocation = new window.BMap.Geolocation();
            const gc = new window.BMap.Geocoder();
            geolocation.getCurrentPosition(function (r) {
                const status = geolocation.getStatus();
                if (status === window.BMAP_STATUS_SUCCESS) {
                    const pt = r.point;
                    gc.getLocation(pt, function (rs) {
                        const {province, city, district, street} = rs.addressComponents;
                        resolve({
                            province,
                            city,
                            district,
                            street,
                            latitude: pt.lat,
                            longitude: pt.lng
                        });
                    });
                } else {
                    reject(status);
                }
            });
        };
    });
}

/**
 * 通过百度地图或者客户端方法定位
 * @param {string} baiduMapAk 非必传 百度秘钥
 */
export function getUserLocation(baiduMapAk) {
    const now = performance.now();
    const {UA, defaultBaiduMapAk} = this
    const ak = baiduMapAk || defaultBaiduMapAk
    return new Promise((resolve, reject) => {
        const getLocation = UA.pregnancyhelper ? getLocationFromNative : getLocationFromBaidu
        getLocation(ak).then(res => {
            console.log(`获取当前地址成功，消耗时间：${Math.round(performance.now() - now)} ms，`, JSON.stringify(res));
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}
export default {
    getUserLocation
}